<template>
  <div class="gallery-area">
    <div class="container-fluid">
      <div class="card-box-style">
        <div
          class="others-title d-flex justify-content-between align-items-center"
        >
          <h3>Galeria de Mídia</h3>

          <div class="add-export text-end">
            <button
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#createMediaModal"
            >
              Adicionar Mídia
            </button>
          </div>
        </div>

        <div
          v-if="notificationMsg"
          class="alert alert-success alert-dismissible fade show"
          role="alert"
          style="margin-top: 20px"
        >
          <strong>Sucesso!</strong> {{ notificationMsg }}
          <button
            type="button"
            class="btn-close"
            @click="notificationMsg = null"
            aria-label="Close"
          ></button>
        </div>

        <div class="row" v-if="mediaList.length > 0">
          <div
            class="col-lg-4 col-sm-6"
            v-for="media in mediaList"
            :key="media.id"
          >
            <div class="single-gallery position-relative">
              <!-- YouTube Video -->
              <div
                v-if="isYoutube(media.url)"
                class="youtube-item"
                @click="openYoutube(media.url)"
                style="cursor: pointer"
              >
                <img
                  :src="`https://img.youtube.com/vi/${getYoutubeId(
                    media.url,
                  )}/0.jpg`"
                  :alt="media.id"
                  style="
                    width: 100%;
                    height: 300px;
                    object-fit: cover;
                    border-radius: 10px;
                  "
                />
                <div class="video-play-overlay">
                  <i class="ri-play-circle-fill"></i>
                </div>
              </div>
              <!-- Standard Photo -->
              <img
                v-else-if="media.type === 'PHOTO'"
                :src="media.url"
                :alt="media.id"
                style="
                  width: 100%;
                  height: 300px;
                  object-fit: cover;
                  border-radius: 10px;
                "
              />
              <!-- Standard Video -->
              <video
                v-else-if="media.type === 'VIDEO'"
                :src="media.url"
                controls
                style="
                  width: 100%;
                  height: 300px;
                  object-fit: cover;
                  border-radius: 10px;
                "
              ></video>

              <button
                class="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                @click="confirmDelete(media.id)"
              >
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>

          <div class="col-lg-12" v-if="totalPages > 1">
            <div class="pagination-area">
              <a
                href="javascript:void(0)"
                class="next page-numbers"
                @click="changePage(currentPage - 1)"
                v-if="currentPage > 1"
              >
                <i class="ri-arrow-left-line"></i>
              </a>
              <span class="page-numbers current" aria-current="page">{{
                currentPage
              }}</span>
              <a
                href="javascript:void(0)"
                class="page-numbers"
                @click="changePage(currentPage + 1)"
                v-if="currentPage < totalPages"
                >{{ currentPage + 1 }}</a
              >

              <a
                href="javascript:void(0)"
                class="next page-numbers"
                @click="changePage(currentPage + 1)"
                v-if="currentPage < totalPages"
              >
                <i class="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <p>Nenhuma mídia encontrada. Faça o upload da primeira!</p>
        </div>
      </div>
    </div>

    <!-- Create Media Modal -->
    <div
      class="modal fade"
      id="createMediaModal"
      tabindex="-1"
      aria-labelledby="createMediaModalLabel"
      aria-hidden="true"
      ref="createMediaModal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createMediaModalLabel">
              Adicionar Nova Mídia
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label"
                >Tipo de Mídia <span class="text-danger">*</span></label
              >
              <select class="form-select" v-model="newMedia.type" required>
                <option value="PHOTO">Imagem (FOTO)</option>
                <option value="VIDEO">Vídeo (MP4, etc)</option>
              </select>
            </div>
            <div class="mb-3" v-if="newMedia.type === 'VIDEO'">
              <label class="form-label">Origem do Vídeo</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="
                    mediaSource === 'file'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  "
                  @click="mediaSource = 'file'"
                  style="flex: 1"
                >
                  Upload
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="
                    mediaSource === 'youtube'
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="mediaSource = 'youtube'"
                  style="flex: 1"
                >
                  YouTube
                </button>
              </div>
            </div>

            <div
              class="mb-3"
              v-if="newMedia.type === 'PHOTO' || mediaSource === 'file'"
            >
              <label class="form-label"
                >Ficheiro (Upload) <span class="text-danger">*</span></label
              >
              <input
                type="file"
                ref="fileUploadInput"
                class="form-control"
                @change="handleFileChange"
                :accept="newMedia.type === 'PHOTO' ? 'image/*' : 'video/*'"
                :multiple="newMedia.type === 'PHOTO'"
              />
              <small
                v-if="newMedia.type === 'PHOTO' && selectedFiles.length > 0"
                class="text-muted d-block mt-1"
              >
                {{ selectedFiles.length }} ficheiro(s) selecionado(s)
              </small>
            </div>

            <div
              class="mb-3"
              v-else-if="newMedia.type === 'VIDEO' && mediaSource === 'youtube'"
            >
              <label class="form-label"
                >Link do YouTube <span class="text-danger">*</span></label
              >
              <input
                type="url"
                v-model="youtubeUrl"
                class="form-control"
                placeholder="https://www.youtube.com/watch?v=..."
                required
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Associar a um Projeto (Opcional)</label>
              <select class="form-select" v-model="newMedia.projectId">
                <option :value="null">Nenhum</option>
                <option
                  v-for="proj in projects"
                  :key="proj.id"
                  :value="proj.id"
                >
                  {{
                    proj.title_pt ||
                    proj.title ||
                    proj.name ||
                    "Projeto sem título"
                  }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Associar a um Evento (Opcional)</label>
              <select class="form-select" v-model="newMedia.eventId">
                <option :value="null">Nenhum</option>
                <option
                  v-for="event in events"
                  :key="event.id"
                  :value="event.id"
                >
                  {{
                    event.title_pt ||
                    event.title ||
                    event.name ||
                    "Evento sem título"
                  }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label"
                >Associar a uma Notícia (Opcional)</label
              >
              <select class="form-select" v-model="newMedia.newsId">
                <option :value="null">Nenhum</option>
                <option v-for="n in news" :key="n.id" :value="n.id">
                  {{ n.title_pt || n.title || "Notícia sem título" }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              :disabled="isUploading"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="submitMedia"
              :disabled="
                isUploading ||
                (newMedia.type === 'PHOTO' && selectedFiles.length === 0) ||
                (newMedia.type === 'VIDEO' &&
                  mediaSource === 'file' &&
                  selectedFiles.length === 0) ||
                (newMedia.type === 'VIDEO' &&
                  mediaSource === 'youtube' &&
                  !youtubeUrl)
              "
            >
              <span
                v-if="isUploading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Media Modal -->
    <div
      class="modal fade"
      id="deleteMediaModal"
      tabindex="-1"
      aria-hidden="true"
      ref="deleteMediaModal"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar Eliminação</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>
              Tem a certeza que deseja eliminar esta mídia? Esta ação não pode
              ser desfeita.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" @click="executeDelete">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mediaService from "../../services/mediaService";
import uploadService from "../../services/uploadService";
import projectsService from "../../services/projectsService";
import eventsService from "../../services/eventsService";
import newsService from "../../services/newsService";
import { Modal } from "bootstrap";

export default {
  name: "GalleryContent",
  data() {
    return {
      mediaList: [],
      currentPage: 1,
      totalPages: 1,
      limit: 12,
      projects: [],
      events: [],
      news: [],
      isUploading: false,
      selectedFiles: [],
      mediaSource: "file", // 'file' ou 'youtube'
      youtubeUrl: "",
      newMedia: {
        type: "PHOTO",
        projectId: null,
        eventId: null,
        newsId: null,
      },
      notificationMsg: null,
      mediaToDeleteId: null,
      createModalInstance: null,
      deleteModalInstance: null,
    };
  },
  mounted() {
    this.fetchMedia();
    this.fetchRelationData();

    // Initialize bootstrap modals
    this.createModalInstance = new Modal(this.$refs.createMediaModal);
    this.deleteModalInstance = new Modal(this.$refs.deleteMediaModal);
  },
  methods: {
    async fetchMedia() {
      try {
        const data = await mediaService.getAll(
          null,
          null,
          this.currentPage,
          this.limit,
        );
        if (data && data.data) {
          this.mediaList = data.data;
          this.totalPages = data.meta?.lastPage || data.totalPages || 1;
        } else if (Array.isArray(data)) {
          this.mediaList = data;
        }
      } catch (error) {
        console.error("Erro ao buscar mídia:", error);
      }
    },
    async fetchRelationData() {
      try {
        // Obter projetos e eventos para as dropdowns
        const projData = await projectsService.getAll(1, 100);
        this.projects = projData.data || projData || [];

        const eventData = await eventsService.getAll(1, 100);
        this.events = eventData.data || eventData || [];

        const newsData = await newsService.getAll(1, 100);
        this.news = newsData.data || newsData || [];
      } catch (error) {
        console.error("Erro ao buscar projetos, eventos ou notícias:", error);
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchMedia();
      }
    },
    handleFileChange(event) {
      const files = event?.target?.files ? Array.from(event.target.files) : [];
      this.selectedFiles = files;
    },
    async submitMedia() {
      if (this.newMedia.type === "PHOTO" && this.selectedFiles.length === 0)
        return;
      if (
        this.newMedia.type === "VIDEO" &&
        this.mediaSource === "file" &&
        this.selectedFiles.length === 0
      )
        return;
      if (
        this.newMedia.type === "VIDEO" &&
        this.mediaSource === "youtube" &&
        !this.youtubeUrl
      )
        return;

      try {
        this.isUploading = true;
        const baseMediaData = {
          type: this.newMedia.type,
        };
        if (this.newMedia.projectId)
          baseMediaData.projectId = this.newMedia.projectId;
        if (this.newMedia.eventId)
          baseMediaData.eventId = this.newMedia.eventId;
        if (this.newMedia.newsId) baseMediaData.newsId = this.newMedia.newsId;

        if (this.newMedia.type === "VIDEO" && this.mediaSource === "youtube") {
          await mediaService.create({
            ...baseMediaData,
            url: this.youtubeUrl,
          });
        } else if (this.newMedia.type === "PHOTO") {
          for (const file of this.selectedFiles) {
            const fileUrl = await uploadService.uploadImage(file);
            await mediaService.create({
              ...baseMediaData,
              url: fileUrl,
            });
          }
        } else {
          const file = this.selectedFiles[0];
          const fileUrl = await uploadService.uploadImage(file);
          await mediaService.create({
            ...baseMediaData,
            url: fileUrl,
          });
        }

        // Reset form
        const createdCount =
          this.newMedia.type === "PHOTO" && this.mediaSource !== "youtube"
            ? this.selectedFiles.length
            : 1;
        this.selectedFiles = [];
        this.youtubeUrl = "";
        this.mediaSource = "file";
        this.newMedia = {
          type: "PHOTO",
          projectId: null,
          eventId: null,
          newsId: null,
        };
        if (this.$refs.fileUploadInput) this.$refs.fileUploadInput.value = "";

        // Close modal, clean up backdrops, and show notification
        this.hideModalAndCleanup(this.createModalInstance);
        this.showNotification(
          createdCount > 1
            ? `${createdCount} mídias foram adicionadas com sucesso à galeria.`
            : "A mídia foi adicionada com sucesso à galeria.",
        );

        this.fetchMedia(); // Refresh list
      } catch (error) {
        console.error("Erro ao fazer upload da mídia:", error);
        alert("Ocorreu um erro ao enviar a mídia. Tente novamente.");
      } finally {
        this.isUploading = false;
      }
    },
    isYoutube(url) {
      if (!url) return false;
      return url.includes("youtube.com") || url.includes("youtu.be");
    },
    getYoutubeId(url) {
      if (!url) return null;
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },
    openYoutube(url) {
      window.open(url, "_blank");
    },
    showNotification(msg) {
      this.notificationMsg = msg;
      setTimeout(() => {
        this.notificationMsg = null;
      }, 4000);
    },
    confirmDelete(id) {
      this.mediaToDeleteId = id;
      this.deleteModalInstance.show();
    },
    async executeDelete() {
      if (!this.mediaToDeleteId) return;
      try {
        await mediaService.remove(this.mediaToDeleteId);
        this.hideModalAndCleanup(this.deleteModalInstance);
        this.mediaToDeleteId = null;
        this.showNotification("A mídia foi eliminada com sucesso.");
        this.fetchMedia();
      } catch (error) {
        console.error("Erro ao excluir mídia:", error);
        alert("Não foi possível excluir a mídia.");
      }
    },
    hideModalAndCleanup(modalInstance) {
      if (modalInstance) {
        modalInstance.hide();
      }
      // Fallback manual cleanup for Bootstrap backdrop and body overflow
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((backdrop) => backdrop.remove());
    },
  },
};
</script>

<style lang="scss">
.single-gallery {
  margin-bottom: 24px;
}

.youtube-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;

  .video-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 48px;
    transition: background 0.2s;
  }

  &:hover .video-play-overlay {
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
